<div class="p-6">
    <h3 class="titre3">{{ 'LIBRARIES_MANAGEMENT.DELETE_LIBRARY_CONFIRM_TITLE' | translate }}</h3>
    <p class="mb-6">{{ 'LIBRARIES_MANAGEMENT.DELETE_LIBRARY_CONFIRM_TEXT' | translate }}</p>
    <div class="flex justify-end space-x-4">
        <button (click)="annuler()" class="btn-secondary-novo">
            {{ 'LIBRARIES_MANAGEMENT.BUTTON_CANCEL' | translate }}
        </button>
        <button (click)="confirmerSuppression()" class="btn-primary-novo focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
            {{ 'LIBRARIES_MANAGEMENT.BUTTON_CONFIRM' | translate }}
        </button>
    </div>
</div>
